__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "vrs-client-ui-portal";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] ||= {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("i18next", "22.5.0", () => (Promise.all([__webpack_require__.e(268), __webpack_require__.e(689)]).then(() => (() => (__webpack_require__(49268))))));
			register("react-dom", "19.2.8", () => (Promise.all([__webpack_require__.e(736), __webpack_require__.e(62)]).then(() => (() => (__webpack_require__(43062))))));
			register("react-helmet-async", "3.0.0", () => (Promise.all([__webpack_require__.e(736), __webpack_require__.e(646)]).then(() => (() => (__webpack_require__(64646))))));
			register("react-i18next", "12.3.1", () => (Promise.all([__webpack_require__.e(736), __webpack_require__.e(896)]).then(() => (() => (__webpack_require__(52896))))));
			register("react-router-dom", "6.30.6", () => (Promise.all([__webpack_require__.e(731), __webpack_require__.e(755), __webpack_require__.e(736), __webpack_require__.e(383)]).then(() => (() => (__webpack_require__(27755))))));
			register("react-router", "6.30.6", () => (Promise.all([__webpack_require__.e(731), __webpack_require__.e(832), __webpack_require__.e(736)]).then(() => (() => (__webpack_require__(25832))))));
			register("react/jsx-runtime", "19.2.8", () => (__webpack_require__.e(803).then(() => (() => (__webpack_require__(13803))))));
			register("react", "19.2.8", () => (__webpack_require__.e(307).then(() => (() => (__webpack_require__(29307))))));
			register("styled-components", "5.3.10", () => (Promise.all([__webpack_require__.e(842), __webpack_require__.e(736), __webpack_require__.e(223)]).then(() => (() => (__webpack_require__(63842))))));
			initExternal(93038);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};